<template>
<div class="min-w-full mx-auto text-center py-6 px-10  text-gray-500 dark:text-slate-100 text-sm  shadow-inner">
  <div class="md:flex justify-between items-center">
    <div class="mb-4 md:mb-0">Created by <a class="hover:underline hover:text-blue-500 text-gray-600 dark:text-slate-50 dark:hover:text-green-400 font-bold" target="_blank" href="https://www.linkedin.com/in/livio-macaj-388422210/">Livio Macaj</a>.</div>

    <div class="flex justify-center">
      <div class="w-8 text-zinc-300 ">
        <a href="https://www.linkedin.com/in/livio-macaj-388422210/" target="_blank" class="hover:text-blue-700 text-2xl dark:hover:text-white">
           <i class="fa-brands fa-linkedin-in"></i>
            
        </a>
      </div>

      <div class="w-8 ml-2 text-zinc-300">
        <a href="https://github.com/Livio21" target="_blank" class="hover:text-gray-700 text-2xl dark:hover:text-white">
          <i class="fa-brands fa-github"></i>
         
        </a>
      </div>
    </div>
  </div>
</div>
</template>
